/**
 * `?next=` is attacker-controllable — it arrives on the URL of the login screen,
 * which is the one page an unauthenticated stranger can always reach. Only a
 * same-site absolute path is honoured, so `//evil.example` and
 * `https://evil.example` land on the home page instead of off-site.
 */
export function safeNext(next: string | null | undefined): string {
  if (!next) return '/';
  if (!next.startsWith('/') || next.startsWith('//')) return '/';
  return next;
}

/** Build the `/login?next=…` target for a location the guard turned away. */
export function loginPathFor(pathname: string, search = ''): string {
  const next = `${pathname}${search}`;
  return next === '/' ? '/login' : `/login?next=${encodeURIComponent(next)}`;
}
